import AccountingScreen from './AccountingScreen';

export default AccountingScreen;
